import { render, staticRenderFns } from "./effectedCountryDistribution.vue?vue&type=template&id=2a3ecefa&scoped=true"
import script from "./effectedCountryDistribution.vue?vue&type=script&lang=js"
export * from "./effectedCountryDistribution.vue?vue&type=script&lang=js"
import style0 from "./effectedCountryDistribution.vue?vue&type=style&index=0&id=2a3ecefa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ecefa",
  null
  
)

export default component.exports